var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#3E5EA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.3333C20.4434 15.3333 17.9584 17.8183 17.9584 20.875C17.9584 23.8733 20.3034 26.3 23.36 26.405C23.4534 26.3933 23.5467 26.3933 23.6167 26.405C23.64 26.405 23.6517 26.405 23.675 26.405C23.6867 26.405 23.6867 26.405 23.6984 26.405C26.685 26.3 29.03 23.8733 29.0417 20.875C29.0417 17.8183 26.5567 15.3333 23.5 15.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4266 29.5083C26.1716 27.3383 20.8633 27.3383 17.585 29.5083C16.1033 30.5 15.2866 31.8417 15.2866 33.2767C15.2866 34.7117 16.1033 36.0417 17.5733 37.0217C19.2066 38.1183 21.3533 38.6667 23.5 38.6667C25.6466 38.6667 27.7933 38.1183 29.4266 37.0217C30.8966 36.03 31.7133 34.7 31.7133 33.2533C31.7016 31.8183 30.8966 30.4883 29.4266 29.5083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3217 21.5633C36.5083 23.8267 34.8983 25.81 32.67 26.0783C32.6583 26.0783 32.6583 26.0783 32.6467 26.0783H32.6117C32.5417 26.0783 32.4717 26.0783 32.4133 26.1017C31.2817 26.16 30.2433 25.7983 29.4617 25.1333C30.6633 24.06 31.3517 22.45 31.2117 20.7C31.13 19.755 30.8033 18.8917 30.3133 18.1567C30.7567 17.935 31.27 17.795 31.795 17.7483C34.0817 17.55 36.1233 19.2533 36.3217 21.5633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.655 32.355C38.5617 33.4867 37.8383 34.4667 36.625 35.1317C35.4583 35.7733 33.9883 36.0767 32.53 36.0417C33.37 35.2833 33.86 34.3383 33.9533 33.335C34.07 31.8883 33.3817 30.5 32.005 29.3917C31.2233 28.7733 30.3133 28.2833 29.3217 27.9217C31.9 27.175 35.1433 27.6767 37.1383 29.2867C38.2117 30.15 38.76 31.235 38.655 32.355Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalD);
export default __webpack_public_path__ + "static/media/totalD.b20bda09.svg";
export { ForwardRef as ReactComponent };